/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCustomerFuel.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/customer-fuel";

export class AutogenModelCustomerFuel<RowType extends ModelRow> extends Endpoint<RowType, RowCustomerFuelFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCustomerFuel extends ModelRow<RowCustomerFuelFields> {
	constructor(values?: Partial<RowCustomerFuelFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCustomerFuelFields {
	amount: number;
	apply_doe_rate: string;
	base_price: number;
	company_id: string;
	credit: string;
	custom_calc: string;
	custom_fsc_hdr_id: string;
	custom_fsc_index_id: string;
	custom_fsc_region_id: string;
	customer_id: string;
	date_opt: string;
	deduct_code_id: string;
	delay_days: number;
	descr: string;
	fsc_cycle_code: string;
	fuel_percent: number;
	fuel_surcharge_id: string;
	fuel_surcharge_pay_id: string;
	fuel_variance: number;
	id: string;
	ltl_code: string;
	ltl_descr: string;
	method: string;
	order_type_id: string;
	region: string;
	round_surchg_calc: string;
	surcharge_type: string;
	surchg_enddt: Date;
	surchg_strtdt: Date;
	truckload_ltl: string;
	weight_type: string;
}

